import {sortBy, reverse} from "lodash"

import API from "@irati/utils/services/API"
import {validateEtag} from "@irati-web/insights/src/helpers/etag/validateEtag"
import endpoints from "../endpoints"

import {insightsErrorHandler} from "./errors"

/** Default service export */
const service = {}

/**
 * Accepts a tenant name and returns the list of schedules
 *
 * @param tenant
 * @returns {PromiseLike<T> | Promise<T>}
 */
service.fetchAllSchedules = (tenant) => {
  return API.get(endpoints.schedules(tenant))
    .then((response) => {
      return reverse(sortBy(response.data.data, ["createdAt"]))
    })
    .catch(insightsErrorHandler)
}

/**
 * Creates a new schedule and have the API inject the fields with default values.
 *
 * A qwirk with the API is that a reference is required for the schedule. This service will automatically generate that
 * for the user, so that it is always unique. We will do this based off the schedule count.
 *
 * The service method will return the ID of the newly created schedule
 *
 * @param tenant
 * @returns {Promise<T>}
 */
service.createScheduleWithDefaults = (tenant = "") => {
  const config = {
    params: {
      withDefaults: "yes"
    }
  }
  const data = {
    reference: "Employee Engagement"
  }

  return API.post(endpoints.schedules(tenant), data, config)
    .then((response) => {
      return response.data.links.self.split("/").pop()
    })
    .catch(insightsErrorHandler)
}

/**
 * Get an existing schedule
 *
 * @param scheduleId
 * @returns {PromiseLike<T> | Promise<T>}
 */
service.fetchSchedule = (tenant, id) => {
  return API.get(endpoints.schedule(tenant, id))
    .then((response) => response.data)
    .catch(insightsErrorHandler)
}

/**
 * Update schedule
 *
 * @param schedule
 * @returns {PromiseLike<T> | Promise<T>}
 */
service.updateSchedule = (schedule) => {
  /** @todo  manually format schedule object here, but prob write a formatter later */
  const {createdAt, id, tenant, lastTriggeredAt, lastENPSTriggeredAt, ...formattedSchedule} = schedule
  const Etag = validateEtag(schedule)
  return API.put(endpoints.schedule(tenant, id), formattedSchedule, Etag)
    .then((response) => response.data)
    .catch(insightsErrorHandler)
}

/** Individual exports */
export const fetchAllSchedules = service.fetchAllSchedules
export const createScheduleWithDefaults = service.createScheduleWithDefaults
export const fetchSchedule = service.fetchSchedule
export const updateSchedule = service.updateSchedule

export default service
